module.exports = __webpack_public_path__ + "img/course-12.b49577e8.png";